import React from 'react';
import styles from './logo.module.scss';
import logoUrl from '@src/assets/img/green_logo.svg';
import { NavLink } from 'react-router-dom';
import { isHomeEDApp } from '@src/constants';

type Props = { isParentApp?: boolean; };

function Logo({ isParentApp }: Props) {
  return (
    <NavLink to={isParentApp ? '/parent/dashboard' : isHomeEDApp ? '/studyplan' : '/dashboard'} className={styles.img}>
      <img className={styles.img} src={logoUrl} alt={'Logo'} />
    </NavLink>
  );
}

export default Logo;
